import { ISOString } from '../../../../interfaces';

export function generateRandomISOString(isUTC = false): ISOString {
    const targetISODate = new Date(Math.floor(Math.random() * Date.now())).toISOString();
    if (isUTC) return targetISODate.split('.').slice(0, 1).join('') + '+00:00';
    return new Date(Math.floor(Math.random() * Date.now())).toISOString();
}
